import { useState, useEffect } from 'react';
import { useGetDiscountQuery } from '../slices/discountApiSlice';

const CountdownBanner = () => {
  const { data: discount } = useGetDiscountQuery(undefined, {
    pollingInterval: 60000, // refresh every minute
  });

  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!discount?.isActive || !discount?.endTime) {
      setTimeLeft(null);
      return;
    }

    const tick = () => {
      const diff = new Date(discount.endTime) - new Date();
      if (diff <= 0) {
        setTimeLeft(null);
        return;
      }
      const totalSecs = Math.floor(diff / 1000);
      const d = Math.floor(totalSecs / 86400);
      const h = Math.floor((totalSecs % 86400) / 3600);
      const m = Math.floor((totalSecs % 3600) / 60);
      const s = totalSecs % 60;
      setTimeLeft({ d, h, m, s });
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [discount]);

  if (!discount?.isActive || !timeLeft) return null;

  const pad = (n) => String(n).padStart(2, '0');

  const parts = [];
  if (timeLeft.d > 0) parts.push(`${timeLeft.d} ימים`);
  parts.push(`${pad(timeLeft.h)}:${pad(timeLeft.m)}:${pad(timeLeft.s)}`);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        backgroundColor: '#6B46C1',
        color: '#fff',
        textAlign: 'center',
        padding: '8px 16px',
        fontSize: '0.95rem',
        fontWeight: '600',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        direction: 'rtl',
      }}
    >
      <span>{discount.headline}</span>
      <span style={{ opacity: 0.7 }}>|</span>
      <span style={{ fontFamily: 'monospace', fontSize: '1rem', letterSpacing: '0.05em' }}>
        {parts.join('  ')}
      </span>
      <span style={{ opacity: 0.7 }}>|</span>
      <span style={{ backgroundColor: '#fff', color: '#6B46C1', borderRadius: '12px', padding: '2px 10px', fontSize: '0.9rem' }}>
        {discount.percentage}% הנחה
      </span>
    </div>
  );
};

export default CountdownBanner;
